import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import { EventsResponse, EventTemplate } from "../types/events";

export const eventKeys = {
  list: ["events"] as const,
  templates: ["events", "templates"] as const,
};

export function useEvents(enabled: boolean) {
  return useQuery({
    queryKey: eventKeys.list,
    queryFn: async () => {
      const res = await api.get<EventsResponse>("/events");
      return res.data;
    },
    enabled,
    refetchInterval: 30_000,
  });
}

export function useEventTemplates(enabled: boolean) {
  return useQuery({
    queryKey: eventKeys.templates,
    queryFn: async () => {
      const res = await api.get<EventTemplate[]>("/events/templates");
      return res.data;
    },
    enabled,
    staleTime: Infinity,
  });
}

export function useLaunchTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ templateId, startsAt }: { templateId: string; startsAt: string }) => {
      const res = await api.post("/admin/events/launch/template", { templateId, startsAt });
      return res.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: eventKeys.list }),
  });
}

export function useCancelEvent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const res = await api.delete(`/admin/events/${id}`);
      return res.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: eventKeys.list }),
  });
}
